export const amenityTitles: Record<string, { [category: string]: string }> = {
  beach: {
    all: 'Beach Access Hotels',
    pool: '',
    spa: '',
    'day room': '',
  },
  'all-inclusive': {
    all: 'All-Inclusive Hotels',
    pool: '',
    spa: '',
    'day room': '',
  },
  'free-parking': {
    all: 'Day Passes with Free Parking',
    pool: 'Pools with Free Parking',
    spa: 'Spas with Free Parking',
    'day room': 'Day Use Rooms with Free Parking',
  },
  'luggage-storage': {
    all: 'Day Passes with Luggage Storage',
    pool: '',
    spa: '',
    'day room': '',
  },
  'airport-shuttle': {
    all: 'Hotels with Airport Shuttle',
    pool: '',
    spa: '',
    'day room': '',
  },
  'cruise-shuttle': {
    all: 'Hotels with Cruise Shuttle',
    pool: '',
    spa: '',
    'day room': '',
  },
  'fitness-center': {
    all: 'Day Passes with Gym Access',
    pool: 'Pools with Gym Access',
    spa: 'Spas with Gym Access',
    'day room': 'Day Use Rooms with Gym Access',
  },
  wheelchair: {
    all: 'Wheelchair Accessible Hotels',
    pool: 'Wheelchair Accessible Hotels',
    spa: 'Wheelchair Accessible Hotels',
    'day room': 'Wheelchair Accessible Day Use Rooms',
  },
  showers: {
    all: 'Day Passes with Showers',
    pool: 'Pools with Showers',
    spa: 'Spas with Showers',
    'day room': 'Day Use Rooms with Showers',
  },
  lockers: {
    all: 'Day Passes with Lockers',
    pool: 'Pools with Lockers',
    spa: 'Spas with Lockers',
    'day room': 'Day Use Rooms with Lockers',
  },
  'outdoor-pool': {
    all: '',
    pool: 'Outdoor Pools',
    spa: '',
    'day room': '',
  },
  'indoor-pool': {
    all: '',
    pool: 'Indoor Pools',
    spa: '',
    'day room': '',
  },
  'infinity-pool': {
    all: '',
    pool: 'Infinity Pools',
    spa: '',
    'day room': '',
  },
  'kiddie-pool': {
    all: '',
    pool: 'Kiddie Pools',
    spa: '',
    'day room': '',
  },
  'rooftop-pool': {
    all: '',
    pool: 'Rooftop Pools',
    spa: '',
    'day room': '',
  },
  hottub: {
    all: '',
    pool: 'Hot Tubs',
    spa: '',
    'day room': '',
  },
  waterslide: {
    all: '',
    pool: 'Waterslides',
    spa: '',
    'day room': '',
  },
  lazyriver: {
    all: '',
    pool: 'Lazy Rivers',
    spa: '',
    'day room': '',
  },
  waterpark: {
    all: '',
    pool: 'Waterparks',
    spa: '',
    'day room': '',
  },
  'splash-pad': {
    all: '',
    pool: 'Pool Splash Pads',
    spa: '',
    'day room': '',
  },
  'relaxation-lounge': {
    all: '',
    pool: '',
    spa: 'Spas with Relaxation Lounges',
    'day room': '',
  },
  sauna: {
    all: '',
    pool: '',
    spa: 'Spas with Saunas',
    'day room': '',
  },
  'infrared-sauna': {
    all: '',
    pool: '',
    spa: 'Spas with Infrared Saunas',
    'day room': '',
  },
  'steam-room': {
    all: '',
    pool: '',
    spa: 'Spas with Steam Rooms',
    'day room': '',
  },
  'salt-room': {
    all: '',
    pool: '',
    spa: 'Spas with Salt Rooms',
    'day room': '',
  },
  'thermal-pool': {
    all: '',
    pool: '',
    spa: 'Spas with Thermal Pools',
    'day room': '',
  },
  'cold-plunge': {
    all: '',
    pool: '',
    spa: 'Spas with Cold Plunges',
    'day room': '',
  },
  'led-and-red-light-therapy': {
    all: '',
    pool: '',
    spa: 'Spas with LED/Red Light Therapy',
    'day room': '',
  },
};

export const productTypeTitles: Record<string, { [category: string]: string }> = {
  1: {
    all: '',
    pool: 'Pool & Beach Cabanas',
    spa: '',
    'day room': '',
  },
  4: {
    all: '',
    pool: 'Pool & Beach Daybeds',
    spa: '',
    'day room': '',
  },
  3: {
    all: '',
    pool: '',
    spa: 'Spa Passes',
    'day room': '',
  },
  7: {
    all: '',
    pool: '',
    spa: 'Massages',
    'day room': '',
  },
  50: {
    all: '',
    pool: '',
    spa: 'Body Treatments',
    'day room': '',
  },
  51: {
    all: '',
    pool: '',
    spa: 'Facials',
    'day room': '',
  },
  52: {
    all: '',
    pool: '',
    spa: 'Nail Services',
    'day room': '',
  },
  53: {
    all: '',
    pool: '',
    spa: 'Couples Treatments',
    'day room': '',
  },
};

export const SrpSeoFAQs: Record<string, { q: string; a: string }[]> = {
  all: [
    {
      q: 'How does a hotel day pass in __CITY__ work?',
      a: '<p>A hotel day pass lets you enjoy a hotel\'s amenities—like the pool, gym, spa, or lounges—without booking a room. It\'s a one-day access pass, perfect for locals or travelers wanting a day of rest and recharge for a few hours. It&apos;s great for an individual day of relaxation, or to experience the pool and hotel amenities with friends, a significant other or as a family day outing.</p><p class="mt-spacing-md">Reserve online at <a href="https://resortpass.com">ResortPass.com</a>, check in at the front desk, and relax for the day.  Check individual hotels for their specific amenities included in their day pass.</p>',
    },
    {
      q: 'Do I need to be a hotel guest to use a day pass in __CITY__?',
      a: '<p>No, day passes allow day access to the amenities at the best hotels in __CITY__ for individuals that are not staying overnight.</p>',
    },
    {
      q: 'How do I book a day pass in __CITY__?',
      a: '<p>Simply go to <a href="https://resortpass.com">ResortPass.com</a>, search "__CITY__" and explore the hotels that are offering day passes to their pools, spas, day rooms and more. We are always adding more hotels and experiences, so check back often to find even more options.</p>',
    },
    {
      q: 'What is your cancellation policy?',
      a: '<p>ResortPass offers flexible cancellation policies for day passes in __CITY__. Most bookings can be canceled or rescheduled up to 24 hours before your scheduled check-in time for a full refund. Late cancellations may incur a fee. Check the specific cancellation policy for your chosen property during booking.</p>',
    },
  ],
  pool: [
    {
      q: 'Can anyone buy a hotel pool pass in __CITY__?',
      a: '<p>Yes, anyone can buy a hotel pool pass in __CITY__! You don&apos;t need to be a hotel guest to enjoy access to luxurious pools at top hotels and resorts. With our extensive inventory, you can choose from a variety of properties, whether you&apos;re looking for a rooftop pool with stunning city views, a serene resort oasis, or a family-friendly destination.</p><p class="mt-spacing-md">Simply book your pass online, and you&apos;re all set for a relaxing day. Explore our wide selection of options and find the perfect pool experience for your needs!</p>',
    },
    {
      q: 'Do I need to be a hotel guest to use a pool in __CITY__?',
      a: '<p>No, you do not need to be a hotel guest to use a pool in __CITY__. ResortPass offers day passes to pools at some of the best hotels and resorts in __CITY__, allowing locals and travelers to enjoy the experience without booking an overnight stay. Learn more about how to maximize your pool day pass experience with Our Guide to Pool Passes on our blog.</p>',
    },
    {
      q: "What's included in a hotel pool pass in __CITY__?",
      a: '<p>A hotel pool pass in __CITY__ typically includes access to the pool area, lounge chairs, and towels. Some passes may also include additional perks like access to private cabanas, food and beverage credits, or discounts at on-site restaurants. Be sure to check the specific details for each property when booking.</p>',
    },
    {
      q: 'How do I book a hotel pool pass in __CITY__?',
      a: '<p>Booking a hotel pool pass in __CITY__ is easy! Visit <a href="https://resortpass.com">ResortPass.com</a>, select __CITY__ as your location, and use our easy filtering options to choose your preferred hotel or resort. Pick your desired date and time, complete the booking process online, and you&apos;ll receive a confirmation with all the details.</p>',
    },
    {
      q: 'What is your cancellation policy?',
      a: '<p>ResortPass offers flexible cancellation policies for pool passes in __CITY__. Most bookings can be canceled or rescheduled up to 24 before your scheduled check-in time for a full refund. Late cancellations may incur a fee. Check the specific cancellation policy for your chosen property during booking.</p>',
    },
  ],
  spa: [
    {
      q: 'What types of spa experiences and treatments do you offer in __CITY__?',
      a: '<p>You can find a wide range of spa experiences and treatments in __CITY__, from spa passes where you can use the amenities in the spa like the sauna and steam room at your leisure, to treatments like massages, facials, and more from some of the best spas in the world.</p>',
    },
    {
      q: 'How much is a spa pass in __CITY__?',
      a: '<p>The cost of a spa pass in __CITY__ varies depending on the property, date, and time of booking. Prices typically range from $40 to $150. You can check the exact price when you select your preferred location and time on <a href="https://resortpass.com">ResortPass.com</a>.</p>',
    },
    {
      q: 'What is included with a spa pass in __CITY__?',
      a: '<p>A spa pass in __CITY__ typically includes access to spa facilities such as relaxation lounges, steam rooms, saunas, and hot tubs. Additional services, like massages or facials, can be purchased during your booking process on <a href="https://resortpass.com">ResortPass.com</a> or by contacting the spa directly. Some passes may also include access to pools or fitness centers. Parking availability and fees vary by location, so check the property details during booking.</p>',
    },
    {
      q: 'How do I check in for my spa pass?',
      a: '<p>Check-in for your spa pass in __CITY__ is simple! Bring your confirmation email and a valid ID to the front desk or spa reception at the property. The staff will guide you through the process and provide access to the facilities.</p>',
    },
    {
      q: 'Are towels, robes, and slippers included, or do I need to bring my own?',
      a: '<p>Towels, robes, and slippers are usually provided with the __CITY__ spa passes we sell. However, it&apos;s always a good idea to confirm the amenities included with your specific pass during the booking process.</p>',
    },
    {
      q: 'What are the most popular spa treatments and experiences in __CITY__?',
      a: '<p>The spa pass is definitely a fan favorite. However, massages for self care or couples massages are popular, as are facials and body treatments. Many of our spas also offer specialized treatments and amenities like LED/red light therapy, salt rooms, thermal pools, cold plunges and more. Check individual spa menus for specific details.</p>',
    },
  ],
  'day room': [
    {
      q: 'What is a day room?',
      a: `<p>A day use room is a hotel room that you can book for a short period during the day, typically between 10am and 5pm. It&apos;s perfect for:</p>
        <ul class="my-spacing-md list-disc">
          <li class="ml-spacing-lg"><strong>Travelers</strong> with long layovers or early arrivals who need a place to rest and recharge.</li>
          <li class="ml-spacing-lg"><strong>Remote workers</strong> looking for a quiet, comfortable space to focus and be productive.</li>
          <li class="ml-spacing-lg"><strong>Staycationers</strong> wanting a relaxing escape without an overnight stay.</li>
          <li class="ml-spacing-lg"><strong>Couples or families</strong> seeking a private space to unwind during a busy day out.</li>
          <li class="ml-spacing-lg"><strong>Event attendees</strong> who need a place to freshen up or change clothes.</li>
        </ul>
        <p class="mt-spacing-md">Whether you&apos;re working, relaxing, or just need a break, a day use room offers the comfort and convenience of a hotel room without the need for an overnight stay.</p>`,
    },
    {
      q: 'How do I book a day use room in __CITY__?',
      a: '<p>Booking a day use room is easy! Visit <a href="https://resortpass.com">ResortPass.com</a>, select __CITY__ as your location, and choose your preferred hotel. Pick your desired date and time, complete the booking process online, and you&apos;ll receive a confirmation with all the details.</p>',
    },
    {
      q: 'What is included with a day room pass in __CITY__?',
      a: '<p>A day room pass typically includes access to a private hotel room for the duration of your booking. Complimentary Wi-Fi, towels, and toiletries are usually provided. You&apos;ll also have access to common spaces such as the lobby, lounges, and on-site restaurants (food and beverages may be an additional cost).</p><p class="mt-spacing-md">Amenities like pools, spas, or gyms are not included unless purchased separately. Be sure to check the specific details during booking to see what&apos;s included with your pass.</p>',
    },
    {
      q: 'Can I bring guests with my day room pass?',
      a: '<p>Yes, you can bring guests, but the number of guests allowed depends on the room&apos;s capacity and the hotel&apos;s policy. Be sure to check the guest limit during booking to avoid any issues at check-in.</p>',
    },
    {
      q: 'How do I check in for my day room?',
      a: '<p>Check-in for your day room is simple! Bring your confirmation email and a valid ID to the hotel&apos;s front desk. The staff will guide you through the process and provide access to your room.</p>',
    },
  ],
};
